const truncateWithEllipses = (text, max) => {
  if (text && text.length > max) {
    return `${text.substr(0, max - 1)}...`;
  }
  return text;
};

export default truncateWithEllipses;
